<template>
  <div
    class="w-full px-2 py-4 border bg-white md:hover:bg-gray-200 md:cursor-pointer border-solid  border-black rounded-lg justify-center items-center gap-2 flex flex-col max-w-[30%] relative"
    :class="{
    'border-2 bg-purple-100 border-purple-500': selected,
    'opacity-50 pointer-events-none': disabled
  }"
    @click="click"
  >
    <i :class="['pi', icon]"/>
    <span class="font-medium text-gray-700 text-center">{{ title }}</span>
    <div class="top-0.5 left-2 absolute w-5">
      <info-button v-if="tooltip">
        {{tooltip}}
      </info-button>
    </div>
  </div>
</template>

<script setup lang="ts">

const emits = defineEmits(['onClick']);
const props = defineProps({
  icon: {type: String, required: true},
  title: {type: String, required: true},
  selected: {type: Boolean, required: false, default: false},
  disabled: {type: Boolean, required: false, default: false},
  tooltip: {type: String, required: false, default: ''},
})

const click = () => {
  emits('onClick')
}
</script>
